import { CheckCircle } from "@phosphor-icons/react";

import { PaymentSourceIcon } from "features/payment-methods/components";
import type { PaymentSource } from "features/payment-methods/types";

interface PaymentSourceProps {
  paymentSource: PaymentSource;
  isSelected: boolean;
  onSelect: () => void;
}

export default function PaymentSourceOption({
  paymentSource,
  isSelected,
  onSelect,
}: PaymentSourceProps) {
  const { type } = paymentSource;

  return (
    <button
      className="flex items-center gap-2 border rounded-2xl px-2 py-2.5 transition-colors border-black-100 hover:bg-black-100 hover:border-black-100"
      onClick={onSelect}
      type="button"
    >
      <PaymentSourceIcon paymentSource={paymentSource} />

      <span className="text-sm-bold">
        {type === "card"
          ? `Card ending with ${paymentSource.card.last4}`
          : paymentSource.paypal.email}
      </span>

      {isSelected && (
        <CheckCircle className="ml-auto size-6 text-purple-600" weight="fill" />
      )}
    </button>
  );
}
